import { render, staticRenderFns } from "./bi-dashboard-view.vue?vue&type=template&id=155ad50a&scoped=true&"
import script from "./bi-dashboard-view.vue?vue&type=script&lang=js&"
export * from "./bi-dashboard-view.vue?vue&type=script&lang=js&"
import style0 from "./bi-dashboard-view.vue?vue&type=style&index=0&id=155ad50a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155ad50a",
  null
  
)

export default component.exports